// Rules as in "collegiate ruled paper."  The faint blue lines used to line
// things up.  When the user enables rules, PDF Snake draws a graph paper
// overlay.
export enum Corner {
    TopLeft = "topLeft",
    TopRight = "topRight",
    BottomLeft = "bottomLeft",
    BottomRight = "bottomRight"
}

function ruleRange(length: number, step: number): number[] {
    const a: number[] = [];
    if (step > 0) {
        for (let i = step; i < length; i+= step) {
            a.push(i);
        }
    } else {
        for (let i = length + step; i > 0; i += step) {
            a.push(i);
        }
    }
    return a;
}

export function drawRules(context: CanvasRenderingContext2D,
    widthPx: number, heightPx: number, stepPx: number, lineThicknessPx: number,
    origin: Corner)
{
    context.beginPath();
    context.strokeStyle = "blue";
    context.globalAlpha = 1.0;
    context.lineWidth = lineThicknessPx;
    context.setLineDash([]);  // Solid.
    // Draw horizontal rules.
    const yStep = [Corner.TopLeft, Corner.TopRight].includes(origin) ? stepPx : -stepPx;
    for (const y of ruleRange(heightPx, yStep)) {
      context.moveTo(0, y);
      context.lineTo(widthPx, y);
    }
    // Draw vertical rules.
    const xStep = [Corner.TopLeft, Corner.BottomLeft].includes(origin)
        ? stepPx : -stepPx;
    for (const x of ruleRange(widthPx, xStep)) {
      context.moveTo(x, 0);
      context.lineTo(x, heightPx);
    }      
    context.stroke();
    
}